// react libraries
import React from 'react';
import { Redirect } from 'react-router-dom';


export default function Logout () {
    localStorage.removeItem('QuikstaysAdminToken');
    return <Redirect to='/login' />;
};
